export default function Hero() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[520px] md:min-h-[640px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20stylized%20artistic%20anime%20themed%20background%20with%20soft%20cherry%20blossom%20petals%20floating%20in%20warm%20golden%20light%2C%20abstract%20gradient%20in%20coral%20and%20cream%20tones%2C%20minimalist%20japanese%20aesthetic%2C%20clean%20and%20airy%20composition%20suitable%20for%20website%20hero%20background%2C%20no%20text%2C%20no%20characters%2C%20soft%20dreamy%20atmosphere%20with%20bokeh%20effects&width=1600&height=900&seq=hero-bg-anime-2026&orientation=landscape"
          alt="91樱花动漫背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 mb-4 md:mb-5">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-fire-fill text-xs text-accent-400"></i>
              </div>
              <span className="text-xs md:text-sm text-white/90 font-medium whitespace-nowrap">
                热门动漫 · 高清在线 · 流畅追番
              </span>
            </div>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-3 md:mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
              91樱花动漫
              <br className="md:hidden" />
              <span className="text-white/95"> — 高清动漫在线观看平台</span>
            </h1>

            <p className="text-sm md:text-base text-white/80 mb-3 md:mb-4 max-w-xl mx-auto lg:mx-0 leading-relaxed">
              全网热门动漫全集在线看，无需下载打开浏览器即可流畅追番。涵盖热播新番、经典番剧、剧场版、OVA等海量资源，日更同步追更不等待。
            </p>
            <p className="text-sm md:text-base text-white/80 mb-5 md:mb-6 max-w-xl mx-auto lg:mx-0 leading-relaxed">
              本站持续更新最新动漫在线看资源，无论你喜欢热血、治愈、悬疑还是搞笑番，这里都能找到你的专属动漫世界。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-6 md:mb-7">
              <div className="flex items-center gap-1.5 text-white/90">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-movie-line text-sm text-accent-400"></i>
                </div>
                <span className="text-xs md:text-sm whitespace-nowrap">日更番剧 <strong className="text-white font-semibold">50+</strong> 部</span>
              </div>
              <div className="flex items-center gap-1.5 text-white/90">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-play-circle-line text-sm text-accent-400"></i>
                </div>
                <span className="text-xs md:text-sm whitespace-nowrap">高清画质 <strong className="text-white font-semibold">1080P</strong></span>
              </div>
              <div className="flex items-center gap-1.5 text-white/90">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-shield-check-line text-sm text-accent-400"></i>
                </div>
                <span className="text-xs md:text-sm whitespace-nowrap">安全无广告 <strong className="text-white font-semibold">纯净追番</strong></span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick('#cards');
                }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white rounded-full text-sm md:text-base font-semibold hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-play-mini-fill text-lg"></i>
                </div>
                开始追番
              </a>
              <a
                href="#features"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick('#features');
                }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-white/15 backdrop-blur-sm border border-white/30 text-white rounded-full text-sm md:text-base font-medium hover:bg-white/25 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[420px] lg:max-w-[480px]">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=A%20beautiful%20stylized%20anime%20illustration%20featuring%20cherry%20blossom%20trees%20under%20a%20warm%20sunset%20sky%20with%20soft%20golden%20and%20coral%20gradients%2C%20dreamy%20atmospheric%20lighting%2C%20Japanese%20anime%20aesthetic%2C%20clean%20composition%20with%20floating%20sakura%20petals%2C%20no%20text%2C%20no%20characters%2C%20cinematic%20quality%2C%20warm%20and%20inviting%20mood&width=960&height=720&seq=hero-visual-anime-2026&orientation=landscape"
                alt="91樱花动漫 - 动漫在线观看平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/50 to-transparent h-1/3"></div>
              <div className="absolute bottom-3 left-3 right-3 flex items-center gap-2 text-white/90 text-xs">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-live-line"></i>
                </div>
                <span>每日同步更新 · 番剧在线看</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}